export const QUERY_PARAM_SERIALIZER_TYPES = {
  CUSTOMER_TAGS_EXCLUDING_PROGRAM_CODE: "customerTagsExcludingProgramCode",
};

export const QUERY_FILTER_TYPES = {
  TEXT: "text",
  SINGLE_SELECT: "singleSelect",
  MULTI_SELECT: "multiSelect",
  MULTI_SELECT_IDS: "multiSelectIds",
  BOOLEAN: "boolean",
};

export const parseCsvParam = (value, delimiter = ",") =>
  String(value || "")
    .split(delimiter)
    .map((item) => item.trim())
    .filter(Boolean);

export const parseBooleanParam = (value) => {
  if (value === "true") return true;
  if (value === "false") return false;
  return null;
};

export const normalizeToStringArray = (
  value,
  objectValueKeys = ["id", "value"]
) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((entry) => {
      if (entry == null) return null;
      if (typeof entry !== "object") return String(entry);
      for (const key of objectValueKeys) {
        if (entry[key] != null) return String(entry[key]);
      }
      return null;
    })
    .filter(Boolean);
};

export const getMapKeyByValue = (valueMap, targetValue) => {
  if (!valueMap || targetValue == null) return "";
  const match = Object.entries(valueMap).find(([, value]) => value === targetValue);
  return match ? match[0] : "";
};

